"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ariaLabel: {
        filterBy: 'Filter by {{criteria}}',
    },
    assessmentFilters: {
        subject: 'Subject',
        gradeLevel: 'Grade Level',
        module: 'Module',
        topic: 'Topic',
        lesson: 'Lesson',
        reset: 'Reset filters',
        assessmentType: 'Assignment Type',
        language: 'Language',
        languageAriaLabel: 'Language {{languageSelected}}',
        englishPlaceHolder: 'English',
        spanishPlaceHolder: 'Spanish',
    },
    assessmentTypeValues: {
        assessment: 'Assessment',
        diagnostic: 'Diagnostic',
        allAssignmentTypeSelected: '{{count}} assignment type selected',
        allAssignmentTypeSelected_plural: '{{count}} assignment types selected',
        fqt: 'Focusing Question Task',
        eom: 'End of Module',
        nr: 'New Read',
        qs: 'Question Set',
        vocabulary: 'Vocabulary',
        benchmark: 'Benchmark',
        equip: 'Equip',
        ma: 'Module Assessment',
        tq: 'Topic Quiz',
    },
    assignmentTypes: {
        EOMA: 'End-of-Module Assessment',
        MMA: 'Mid-Module Assessment',
        TQ: 'Topic Quiz',
        FQT: 'Focusing Question Task',
        NR: 'New Read',
        MA: 'Module Assessment',
        VOC: 'Vocabulary',
        QS: 'Question Set',
        Benchmark: 'Benchmark',
        Equip: 'Equip',
        'Question Set': 'Question Set',
        CC: 'Conceptual Checkpoint',
        CP: 'Capstone Project',
        EC: 'Engineering Challenge',
        EoMT: 'End-of-Module Task',
        EoSA: 'End-of-Spotlight Assessment',
        MT: 'Module Task',
        SC: 'Science Challenge',
        SQ: 'Safety Quiz',
        RCT: 'Reading Comprehension Task',
        LCT: 'Listening Comprehension Task',
        WWEOM: 'End of Module',
    },
};
